import { useContext } from 'react';
import { TrackingContext } from '@elementary/common-ui/providers/tracking';
import { MutationError } from '@elementary/common-ui/types/mutationTypes';

const useSendTracking = () => {
  const tracking = useContext(TrackingContext);
  const trackingEvents = tracking?.analytics.events;

  const sendTrackingWithoutSensitiveData = ({
    error,
    eventName,
  }: {
    error: MutationError;
    eventName?: string;
  }) => {
    const errorResponseWithoutSensitiveData = { ...error.response };
    delete errorResponseWithoutSensitiveData.config.data;
    delete errorResponseWithoutSensitiveData.config.headers;
    tracking?.sendTrackingEvent({
      eventName,
      properties: {
        error_response: errorResponseWithoutSensitiveData,
        error_message: error.message,
      },
    });
  };

  return { sendTrackingWithoutSensitiveData, trackingEvents, tracking };
};

export default useSendTracking;
